export default __webpack_public_path__ + "static/project-page-b7d6f40a8367d74955a3ec000f7101c1.png";